// declare module '@yaireo/tagify';
// declare module '@yaireo/tagify/dist/react.tagify';
export const API_ERROR = 'Something went wrong!!'
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY 

export const maskEmail = (value) => {
  if (!value || typeof value !== 'string') return value || '---'

  const [localPart = '', domain = ''] = value.split('@')
  if (!localPart || !domain) return value

  if (localPart.length <= 2) {
    return `${localPart[0] || '*'}*@${domain}`
  }

  return `${localPart.slice(0, 2)}${'*'.repeat(Math.max(localPart.length - 2, 3))}@${domain}`
}

export const maskPhone = (value) => {
  if (value === null || value === undefined) return '---'

  const input = String(value)
  const digits = input.replace(/\D/g, '')
  if (!digits) return input

  if (digits.length <= 4) return '*'.repeat(digits.length)

  const lastFour = digits.slice(-4)
  return `${'*'.repeat(Math.max(digits.length - 4, 4))}${lastFour}`
}

export const maskAddress = (value) => {
  if (!value || typeof value !== 'string') return value || '---'

  const trimmed = value.trim()
  if (trimmed.length <= 12) return `${trimmed.slice(0, 4)}***`

  return `${trimmed.slice(0, 10)}...`
}



export const isFile = (value) => {
  if (value instanceof File) return true
  if (value instanceof FileList) return value.length > 0 && value[0] instanceof File
  return Array.isArray(value) && value[0] instanceof File
}

export function checkFileType(value, dummy) {
  if (typeof value === 'string') {
    const newValue = value?.split('?')[0]
    // Check if the value is a URL
    if (newValue.match(/\.(jpeg|jpg|png|gif|pdf|svg)$/i)) {
      if (newValue.match(/\.(jpeg|jpg|png|gif|svg)$/i)) {
        return (
          <img
            style={{
              width: '80%',
              height: '80%',
            }}
            src={value}
            alt=''
          />
        )
      } else if (newValue.match(/\.pdf$/i)) {
        return (
          <iframe
          title="Document Viewer"
            style={{
              width: '80%',
            }}
            src={value}
            frameborder='0'
          ></iframe>
        )
      }
    } else {
      return (
        <img
          style={{
            width: '80%',
            height: '80%',
          }}
          src={dummy}
          alt=''
        />
      )
    }
  } else if (value && value[0] instanceof File) {
    // Check if the value is a File object
    const allowedExtensions = ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'svg']
    const fileExtension = value[0].name.split('.').pop().toLowerCase()
    if (allowedExtensions.includes(fileExtension)) {
      if (fileExtension.match(/(jpeg|jpg|png|gif|svg)$/i)) {
        return (
          <img
            style={{
              width: '80%',
              height: '80%',
            }}
            src={window.URL.createObjectURL(value[0])}
            alt=''
          />
        )
      } else if (fileExtension === 'pdf') {
        return (
          <iframe
          title="Document Viewer"
            style={{
              width: '80%',
            }}
            src={window.URL.createObjectURL(value[0])}
            frameborder='0'
          ></iframe>
        )
      }
    } else {
      return (
        <img
          style={{
            width: '80%',
            height: '80%',
          }}
          src={dummy}
          alt=''
        />
      )
    }
  } else {
    return (
      <img
        style={{
          width: '80%',
          height: '80%',
        }}
        src={dummy}
        alt=''
      />
    )
  }
}

export const sortText = (text) => {
  return text?.length > 35 ? `${text?.substring(0, 25)}...` : text
}
export function exportToCsv(data, headers, fileName = 'Data') {
  const escapeValue = (value) => {
    if (value === null || value === undefined) return '""'

    return `"${String(value)
      .replace(/"/g, '""')      // escape quotes
      .replace(/\r?\n/g, ' ')  // remove line breaks
    }"`
  }

  const csvRows = []

  // header row
  csvRows.push(headers.map(escapeValue).join(','))

  // data rows
  data.forEach((row) => {
    csvRows.push(row.map(escapeValue).join(','))
  })

  const csvString = csvRows.join('\n')

  // UTF-8 BOM for Excel
  const blob = new Blob(
    ['\uFEFF' + csvString],
    { type: 'text/csv;charset=utf-8;' }
  )

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${fileName}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


export function convertToTitleCase(inputString) {
  return inputString
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
